// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fbbdb026","732":"b0ab6b24","977":"7f4fc1ec"}[chunkId] + ".chunk.js";
};